import React, { useEffect, useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import {
  MapPin,
  Star,
  Facebook,
  Clock,
  Phone,
  Menu,
  X,
  Stethoscope,
  Sparkles,
  Heart,
  Search,
  Instagram,
  Users,
  Award,
  ChevronRight,
} from 'lucide-react';

const TikTokIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.17 8.17 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z"/>
  </svg>
);

const WhatsAppIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

// ---------------------------------------------------------------------------
// DATA
// ---------------------------------------------------------------------------

const SERVICES = [
  {
    icon: Sparkles,
    title: 'Servicio Podológico Integral',
    price: '$380',
    description:
      'El servicio más completo para tus pies: valoración completa, detección de onicopatías, atención de uñas encarnadas, corte profiláctico, desbridamiento de callosidades, limpieza de canales ungueales y masaje relajante 5-10 min.',
  },
  {
    icon: Heart,
    title: 'Manicure Clínico',
    price: '$290',
    description:
      'Atención desde un enfoque clínico para las manos: valoración, corte profiláctico de uñas, limpieza de cutícula y masaje relajante.',
  },
  {
    icon: Stethoscope,
    title: 'Reflexología Podal',
    price: '$300',
    description:
      'Terapia manual complementaria que estimula zonas reflejas en los pies para mejorar la salud, aliviar el dolor y promover la relajación.',
  },
  {
    icon: Search,
    title: 'Consulta Podológica',
    price: '$120',
    description:
      'Valoración integral, detección de onicopatías y recomendaciones. Gratuita si realizas el Servicio Podológico Integral.',
  },
];

const waMsg = (sucursal) =>
  `https://wa.me/${sucursal}?text=${encodeURIComponent('Hola, me gustaría agendar una cita en Pie Feliz')}`;

const LOCATIONS = [
  {
    name: 'Pie Feliz 3a. Sur Poniente',
    address: '3a. Sur Poniente No. 654, Col. Centro, Tuxtla Gutiérrez, Chis. CP 29066',
    rating: 4.7,
    reviews: 186,
    whatsapp: waMsg('529617090080'),
    phone: 'tel:+529616000481',
    phoneDisplay: '961 600 0481',
    maps: 'https://maps.app.goo.gl/CtXSDu73amYXmrVCA',
    facebook: 'https://www.facebook.com/PieFelizCentro?locale=es_LA',
    instagram: 'https://www.instagram.com/pie_feliz_centro_tuxtla/',
    tiktok: 'https://www.tiktok.com/@piefeliztuxtla3asur',
  },
  {
    name: 'Pie Feliz Ángel Albino Corzo',
    address: 'Blvd. Ángel Albino Corzo 955, Real del Bosque, 29000 Tuxtla Gutiérrez, Chis.',
    rating: 4.7,
    reviews: 92,
    whatsapp: waMsg('529616543531'),
    phone: 'tel:+529616041327',
    phoneDisplay: '961 604 1327',
    maps: 'https://maps.app.goo.gl/yvheBTierS3puGuk7',
    facebook: 'https://www.facebook.com/PieFelizAlbinoCorzoTuxtla/',
    instagram: 'https://www.instagram.com/pie_feliz_oriente_tuxtla/',
    tiktok: 'https://www.tiktok.com/@piefeliz.oriente',
  },
  {
    name: 'Pie Feliz 3a. Oriente Norte',
    address: '3a Oriente Norte No. 256, San Marcos, CP 29000, Tuxtla Gutiérrez, Chis.',
    rating: 4.8,
    reviews: 81,
    whatsapp: waMsg('529611888805'),
    phone: 'tel:+529616883188',
    phoneDisplay: '961 688 3188',
    maps: 'https://maps.app.goo.gl/YKrq532AEcVCPBpb8',
    facebook: 'https://www.facebook.com/people/Pie-Feliz-3o-Oriente-Norte/100054372256781/',
    instagram: 'https://www.instagram.com/podologiapiefelizoriente/',
    tiktok: 'https://www.tiktok.com/@piefeliz3ote',
  },
  {
    name: 'Pie Feliz Belisario Domínguez',
    address: 'Blvd. Belisario Domínguez 3090, Jardines de Tuxtla, 29020 Tuxtla Gutiérrez, Chis.',
    rating: 4.9,
    reviews: 103,
    whatsapp: waMsg('529613001274'),
    phone: 'tel:+529612235382',
    phoneDisplay: '961 223 5382',
    maps: 'https://maps.app.goo.gl/K9y5z9DxF6RkrgibA',
    facebook: 'https://www.facebook.com/PodologiaBelisarioDominguez/',
    instagram: 'https://www.instagram.com/piefeliz_poniente_tuxtla/',
    tiktok: 'https://www.tiktok.com/@piefelizponiente',
  },
];

const TESTIMONIALS = [
  {
    name: 'María González',
    rating: 5,
    text: 'Excelente atención, muy profesionales y el tratamiento fue completamente sin dolor. Mis pies quedaron perfectos.',
  },
  {
    name: 'Carlos Ramírez',
    rating: 5,
    text: 'La higiene y el trato son impecables. Como paciente diabético, encontré el cuidado que necesitaba. Totalmente recomendado.',
  },
  {
    name: 'Ana Martínez',
    rating: 5,
    text: 'Después de años con callosidades, finalmente pude caminar sin molestias. El servicio es de primera calidad.',
  },
];

const GALLERY_IMAGES = [
  { src: '/images/equipo.jpeg', alt: 'Equipo de trabajo de Pie Feliz' },
  { src: '/images/sillas-especiales.jpeg', alt: 'Sillas especiales podológicas' },
  { src: '/images/producto.jpeg', alt: 'Productos utilizados en Pie Feliz' },
  { src: '/images/entrada-cerca.jpeg', alt: 'Entrada de la clínica 3a Sur' },
];

const WHY_US = [
  { icon: Star, label: '+450 reseñas en Google', sublabel: 'Calificación promedio 4.8 estrellas' },
  { icon: MapPin, label: '4 sucursales', sublabel: 'Tuxtla Gutiérrez, Chiapas' },
  { icon: Users, label: 'Personal especializado', sublabel: 'Altamente capacitado' },
  { icon: Award, label: 'Más de 10 años', sublabel: 'De experiencia clínica' },
];

const WA_MSG = encodeURIComponent('Hola, me gustaría agendar una cita en Pie Feliz');

// Sucursal principal para footer y hero CTA
const MAIN_WHATSAPP = `https://wa.me/529617090080?text=${WA_MSG}`;

// ---------------------------------------------------------------------------
// HELPERS
// ---------------------------------------------------------------------------

const imgUrl = (path) => process.env.PUBLIC_URL + path;

const openLink = (url) => window.open(url, '_blank', 'noopener,noreferrer');

const StarRating = ({ rating, size = 'sm' }) => {
  const sizeClass = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          className={`${sizeClass} ${
            star <= Math.round(rating)
              ? 'text-yellow-400 fill-yellow-400'
              : 'text-gray-300 fill-gray-300'
          }`}
        />
      ))}
    </div>
  );
};

// ---------------------------------------------------------------------------
// MAIN COMPONENT
// ---------------------------------------------------------------------------

const NAV_LINKS = [
  { label: 'Servicios', id: 'servicios' },
  { label: 'Reseñas', id: 'reseñas' },
  { label: 'Sucursales', id: 'sucursales' },
];

const Home = () => {
  const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsHeaderScrolled(window.scrollY > 20);
      if (menuOpen) setMenuOpen(false);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [menuOpen]);

  const scrollToSection = (id) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen bg-white">

      {/* ------------------------------------------------------------------ */}
      {/* HEADER STICKY                                                        */}
      {/* ------------------------------------------------------------------ */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isHeaderScrolled || menuOpen
            ? 'bg-white/95 backdrop-blur-md shadow-md'
            : 'bg-white'
        }`}
      >
        <nav className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center gap-2">
              <img
                src={imgUrl('/images/logo.jpeg')}
                alt="Pie Feliz"
                className="h-10 w-auto rounded-lg object-contain"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  e.currentTarget.nextSibling.style.display = 'block';
                }}
              />
              <span className="text-2xl font-bold text-purple-700 hidden" aria-hidden="true">
                Pie Feliz
              </span>
            </div>

            {/* Nav links — desktop */}
            <div className="hidden md:flex items-center gap-8">
              {NAV_LINKS.map(({ label, id }) => (
                <button
                  key={id}
                  onClick={() => scrollToSection(id)}
                  className="text-purple-700 hover:text-purple-900 font-medium transition-colors"
                >
                  {label}
                </button>
              ))}
            </div>

            {/* Derecha: CTA + hamburguesa */}
            <div className="flex items-center gap-2">
              <Button
                onClick={() => openLink(MAIN_WHATSAPP)}
                className="bg-pink-500 hover:bg-pink-600 text-white font-semibold px-4 py-2 rounded-full transition-all duration-300 hover:scale-105 shadow-lg text-sm"
              >
                <WhatsAppIcon size={16} />
                <span className="ml-1.5 hidden sm:inline">Agendar Cita</span>
              </Button>

              {/* Hamburguesa — solo móvil */}
              <button
                onClick={() => setMenuOpen((o) => !o)}
                className="md:hidden p-2 rounded-lg text-purple-700 hover:bg-purple-50 transition-colors"
                aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
              >
                {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>

          {/* Menú móvil desplegable */}
          {menuOpen && (
            <div className="md:hidden border-t border-purple-100 mt-3 pt-3 pb-2 flex flex-col gap-1">
              {NAV_LINKS.map(({ label, id }) => (
                <button
                  key={id}
                  onClick={() => scrollToSection(id)}
                  className="w-full text-left px-3 py-3 text-purple-700 font-medium rounded-lg hover:bg-purple-50 transition-colors"
                >
                  {label}
                </button>
              ))}
            </div>
          )}
        </nav>
      </header>

      {/* ------------------------------------------------------------------ */}
      {/* HERO                                                                  */}
      {/* ------------------------------------------------------------------ */}
      <section className="pt-28 pb-20 px-4 bg-gradient-to-br from-gray-50 to-purple-50">
        <div className="container mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">

            {/* Left: texto */}
            <div className="space-y-6">
              <span className="inline-block bg-teal-100 text-teal-700 font-semibold text-sm px-4 py-1.5 rounded-full tracking-wide uppercase">
                Clínica Podológica en Tuxtla Gutiérrez
              </span>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-purple-700 leading-tight">
                Tus pies merecen el mejor cuidado
              </h1>

              <p className="text-lg text-gray-600 leading-relaxed">
                Especialistas en podología clínica. Eliminamos el dolor, tratamos las uñas
                encarnadas y callosidades con técnicas profesionales. 4 sucursales listas para atenderte.
              </p>

              {/* Badge rating */}
              <div className="inline-flex items-center gap-3 bg-white rounded-2xl px-5 py-3 shadow-md border border-purple-100">
                <StarRating rating={4.8} size="md" />
                <span className="font-bold text-purple-700 text-lg">4.8</span>
                <span className="text-gray-500 text-sm">· +450 reseñas en Google</span>
              </div>

              <div className="pt-2">
                <Button
                  onClick={() => openLink(MAIN_WHATSAPP)}
                  size="lg"
                  className="bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold px-8 py-6 text-lg rounded-full transition-all duration-300 hover:scale-105 shadow-xl"
                >
                  <WhatsAppIcon size={20} />
                  <span className="ml-2">Agendar por WhatsApp</span>
                </Button>
              </div>
            </div>

            {/* Right: imagen */}
            <div className="relative mt-6 md:mt-0 pb-6 pl-6 md:pb-0 md:pl-0">
              <div className="rounded-3xl overflow-hidden shadow-2xl aspect-[4/3]">
                <img
                  src={imgUrl('/images/entrada-principal.jpeg')}
                  alt="Entrada principal Pie Feliz 3a Sur"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-purple-900/30 to-transparent" />
              </div>

              {/* Rating flotante */}
              <div className="absolute bottom-0 left-0 bg-white p-4 rounded-2xl shadow-xl border border-purple-100">
                <div className="flex items-center gap-2">
                  <Star className="w-6 h-6 text-yellow-400 fill-yellow-400" />
                  <span className="text-2xl font-bold text-purple-700">4.8</span>
                  <span className="text-gray-500 text-sm">/ 5.0</span>
                </div>
                <p className="text-xs text-gray-400 mt-0.5">Calificación promedio Google</p>
              </div>

              {/* Badge sucursales */}
              <div className="absolute top-0 right-0 md:-top-4 md:-right-4 bg-teal-500 text-white px-4 py-2 rounded-2xl shadow-lg font-bold text-sm">
                4 Sucursales
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ------------------------------------------------------------------ */}
      {/* SUCURSALES                                                            */}
      {/* ------------------------------------------------------------------ */}
      <section id="sucursales" className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-5xl font-bold text-purple-700 mb-3">
              Encuentra tu clínica más cercana
            </h2>
            <p className="text-gray-600 text-lg">
              4 sucursales en Tuxtla Gutiérrez para tu comodidad
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {LOCATIONS.map(
              ({ name, address, rating, reviews, whatsapp, phone, phoneDisplay, maps, facebook, instagram, tiktok }, i) => (
                <Card
                  key={i}
                  className="border border-purple-100 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                >
                  <CardContent className="p-5 flex flex-col gap-4 h-full">
                    {/* Header */}
                    <div className="flex items-start justify-between gap-2">
                      <MapPin className="w-5 h-5 text-teal-500 flex-shrink-0 mt-0.5" />
                      <div className="flex items-center gap-1 ml-auto">
                        <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                        <span className="font-bold text-purple-700 text-sm">{rating}</span>
                        <span className="text-gray-400 text-xs">({reviews})</span>
                      </div>
                    </div>

                    {/* Nombre */}
                    <h3 className="font-bold text-purple-700 text-sm leading-snug">{name}</h3>

                    {/* Dirección */}
                    <p className="text-gray-500 text-xs leading-relaxed">{address}</p>

                    {/* Horario */}
                    <div className="flex items-center gap-2 text-gray-500 text-xs">
                      <Clock className="w-3.5 h-3.5 text-teal-500 flex-shrink-0" />
                      <span>Lunes a Sábado 9:00 AM – 7:00 PM</span>
                    </div>

                    {/* Redes sociales */}
                    <div className="flex items-center gap-3 pt-1">
                      <a href={facebook} target="_blank" rel="noopener noreferrer"
                        className="text-gray-400 hover:text-purple-700 transition-colors" aria-label="Facebook">
                        <Facebook className="w-4 h-4" />
                      </a>
                      <a href={instagram} target="_blank" rel="noopener noreferrer"
                        className="text-gray-400 hover:text-pink-500 transition-colors" aria-label="Instagram">
                        <Instagram className="w-4 h-4" />
                      </a>
                      <a href={tiktok} target="_blank" rel="noopener noreferrer"
                        className="text-gray-400 hover:text-gray-900 transition-colors" aria-label="TikTok">
                        <TikTokIcon size={15} />
                      </a>
                    </div>

                    {/* Teléfono fijo */}
                    <a href={phone}
                      className="flex items-center gap-2 text-gray-500 hover:text-purple-700 transition-colors text-xs"
                    >
                      <Phone className="w-3.5 h-3.5 text-teal-500 flex-shrink-0" />
                      <span>{phoneDisplay} <span className="text-gray-400">(llamadas)</span></span>
                    </a>

                    {/* Botones acción */}
                    <div className="flex flex-col gap-2 mt-auto">
                      <Button
                        onClick={() => openLink(whatsapp)}
                        className="w-full bg-[#25D366] hover:bg-[#1ebe5d] text-white text-xs font-semibold rounded-full py-2 transition-all hover:scale-105"
                      >
                        <WhatsAppIcon size={14} />
                        <span className="ml-1.5">WhatsApp</span>
                      </Button>
                      <Button
                        onClick={() => openLink(maps)}
                        variant="outline"
                        className="w-full border-purple-700 text-purple-700 hover:bg-purple-50 text-xs font-semibold rounded-full py-2 transition-colors"
                      >
                        <MapPin className="w-3.5 h-3.5 mr-1.5" />
                        Ver en Mapa
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              )
            )}
          </div>
        </div>
      </section>

      {/* ------------------------------------------------------------------ */}
      {/* POR QUE ELEGIRNOS                                                    */}
      {/* ------------------------------------------------------------------ */}
      <section className="py-16 px-4 bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-purple-700 mb-3">
              ¿Por qué elegir Pie Feliz?
            </h2>
            <p className="text-gray-600 text-lg max-w-xl mx-auto">
              La clínica podológica de mayor confianza en Tuxtla Gutiérrez
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {WHY_US.map(({ icon: Icon, label, sublabel }, i) => (
              <div
                key={i}
                className="flex flex-col items-center text-center p-6 rounded-2xl bg-gradient-to-b from-purple-50 to-white border border-purple-100 hover:shadow-lg transition-shadow duration-300"
              >
                <div className="bg-purple-700 p-3 rounded-full mb-4">
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <p className="font-bold text-purple-700 text-sm md:text-base leading-tight">{label}</p>
                <p className="text-gray-500 text-xs md:text-sm mt-1">{sublabel}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ------------------------------------------------------------------ */}
      {/* SERVICIOS                                                             */}
      {/* ------------------------------------------------------------------ */}
      <section id="servicios" className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-5xl font-bold text-purple-700 mb-4">
              Nuestros Servicios
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Atención profesional con personal especializado y precios accesibles
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {SERVICES.map(({ icon: Icon, title, price, description }, i) => (
              <Card
                key={i}
                className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden"
              >
                <div className="bg-gradient-to-br from-purple-600 to-purple-800 p-6 flex items-center justify-between">
                  <Icon className="w-10 h-10 text-white/90" />
                  <span className="text-2xl font-extrabold text-white">{price}</span>
                </div>
                <CardContent className="p-5 space-y-3">
                  <h3 className="text-base font-bold text-purple-700 leading-snug">{title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{description}</p>
                  <Button
                    onClick={() => openLink(MAIN_WHATSAPP)}
                    className="w-full bg-pink-500 hover:bg-pink-600 text-white rounded-full text-sm font-semibold mt-2 transition-all hover:scale-105"
                  >
                    <WhatsAppIcon size={16} />
                    <span className="ml-1.5">Agendar</span>
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* ------------------------------------------------------------------ */}
      {/* GALERIA                                                               */}
      {/* ------------------------------------------------------------------ */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-purple-700 mb-3">
              Nuestras Instalaciones
            </h2>
            <p className="text-gray-600 text-lg">
              Espacios limpios, cómodos y equipados para tu bienestar
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
            {GALLERY_IMAGES.map(({ src, alt }, i) => (
              <div
                key={i}
                className={`overflow-hidden rounded-2xl shadow-md group ${
                  i === 0 ? 'md:col-span-2 md:row-span-2' : ''
                }`}
              >
                <img
                  src={imgUrl(src)}
                  alt={alt}
                  className="w-full h-full object-cover aspect-square md:aspect-auto transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  style={i === 0 ? { minHeight: '300px' } : { minHeight: '180px' }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ------------------------------------------------------------------ */}
      {/* RESENAS                                                               */}
      {/* ------------------------------------------------------------------ */}
      <section id="reseñas" className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-bold text-purple-700 mb-4">
              Lo que dicen nuestros pacientes
            </h2>

            {/* Stat global */}
            <div className="inline-flex items-center gap-4 bg-white rounded-2xl px-8 py-5 shadow-md border border-purple-100 mt-4">
              <div className="flex flex-col items-center">
                <span className="text-4xl font-extrabold text-purple-700">4.8</span>
                <StarRating rating={4.8} size="md" />
                <span className="text-gray-500 text-xs mt-1">en Google</span>
              </div>
              <div className="w-px h-14 bg-purple-100" />
              <div className="text-left">
                <p className="font-bold text-purple-700 text-lg">+450 reseñas</p>
                <p className="text-gray-500 text-sm">en todas las sucursales</p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mt-8">
            {TESTIMONIALS.map(({ name, rating, text }, i) => (
              <Card
                key={i}
                className="border-none shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <CardContent className="p-6 space-y-4">
                  <StarRating rating={rating} size="sm" />
                  <p className="text-gray-700 italic leading-relaxed text-sm">"{text}"</p>
                  <p className="font-semibold text-purple-700 text-sm">— {name}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* ------------------------------------------------------------------ */}
      {/* BANNER CTA FINAL                                                      */}
      {/* ------------------------------------------------------------------ */}
      <section className="py-20 px-4 bg-gradient-to-br from-purple-700 to-purple-900">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
            ¿Listo para caminar sin dolor?
          </h2>
          <p className="text-purple-200 text-lg mb-10 max-w-xl mx-auto">
            Nuestros especialistas están listos para atenderte. Agenda tu cita hoy mismo,
            sin filas y sin espera.
          </p>
          <Button
            onClick={() => openLink(MAIN_WHATSAPP)}
            size="lg"
            className="bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold px-10 py-7 text-xl rounded-full transition-all duration-300 hover:scale-110 shadow-2xl"
          >
            <WhatsAppIcon size={24} />
            <span className="ml-3">Agendar Cita por WhatsApp</span>
          </Button>
        </div>
      </section>

      {/* ------------------------------------------------------------------ */}
      {/* FOOTER                                                                */}
      {/* ------------------------------------------------------------------ */}
      <footer className="bg-gray-900 text-white py-12 px-4">
        <div className="container mx-auto">
          <div className="grid md:grid-cols-3 gap-8">

            {/* Marca */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={imgUrl('/images/logo.jpeg')}
                  alt="Pie Feliz"
                  className="h-10 w-auto rounded-lg object-contain"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
                <span className="text-xl font-bold">Pie Feliz</span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                Atención Podológica Profesional en Tuxtla Gutiérrez, Chiapas. Cuidamos tus pies con
                técnicas clínicas especializadas.
              </p>
            </div>

            {/* Contacto */}
            <div>
              <h4 className="text-base font-bold mb-4">Sucursal Principal</h4>
              <div className="space-y-2 text-gray-400 text-sm">
                <p>3a. Sur Poniente No. 654, Col. Centro</p>
                <p>Tuxtla Gutiérrez, Chis. CP 29066</p>
                <div className="flex items-center gap-2 mt-3">
                  <Clock className="w-4 h-4 text-teal-500" />
                  <span>Lun – Sáb: 9:00 AM – 7:00 PM</span>
                </div>
              </div>
            </div>

            {/* Redes sociales */}
            <div>
              <h4 className="text-base font-bold mb-4">Síguenos</h4>
              <div className="flex gap-3">
                <a
                  href="https://www.facebook.com/PieFelizCentro?locale=es_LA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-purple-700 transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook className="w-4 h-4" />
                </a>
                <a
                  href="https://www.instagram.com/pie_feliz_centro_tuxtla/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-pink-600 transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram className="w-4 h-4" />
                </a>
                <a
                  href={MAIN_WHATSAPP}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-[#25D366] transition-colors"
                  aria-label="WhatsApp"
                >
                  <WhatsAppIcon size={16} />
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-gray-500 text-sm">
            <p>&copy; 2026 Pie Feliz. Todos los derechos reservados.</p>
            <button
              onClick={() => scrollToSection('servicios')}
              className="flex items-center gap-1 hover:text-teal-400 transition-colors"
            >
              Ver servicios <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </footer>

      {/* ------------------------------------------------------------------ */}
      {/* BOTON FLOTANTE WHATSAPP (visible en todos los dispositivos)          */}
      {/* ------------------------------------------------------------------ */}
      <button
        onClick={() => openLink(MAIN_WHATSAPP)}
        aria-label="Contactar por WhatsApp"
        className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 active:scale-95"
        style={{ backgroundColor: '#25D366' }}
      >
        <WhatsAppIcon size={28} />
      </button>

    </div>
  );
};

export default Home;
